/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProvidedItem from './provided-item';
import ProvidedItemDetail from './provided-item-detail';
import ProvidedItemUpdate from './provided-item-update';
import ProvidedItemDeleteDialog from './provided-item-delete-dialog';

const ProvidedItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProvidedItem />} />
    <Route path="new" element={<ProvidedItemUpdate />} />
    <Route path=":id">
      <Route index element={<ProvidedItemDetail />} />
      <Route path="edit" element={<ProvidedItemUpdate />} />
      <Route path="delete" element={<ProvidedItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProvidedItemRoutes;
